import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IProduct } from "../productModal";

export const getAllProduct = createAsyncThunk(
  "Product/FindAllProduct",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Product/FindAllProduct`,
        {
          ProductName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Product:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createProduct = createAsyncThunk(
  "Product/InsertProduct",
  async (ProductData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Product/InsertProduct`,
        ProductData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Product:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateProduct = createAsyncThunk(
  "Product/UpdateProduct",
  async (ProductData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Product/UpdateProduct`,
        ProductData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Product :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "Product/DeleteProduct",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Product/DeleteProduct`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Product :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getProductByID = createAsyncThunk(
  "Product/FindByIDProduct",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Product/FindByIDProduct`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ProductName: result?.ProductName,
        ProductURL: result?.ProductURL,
        CategoryID: result?.CategoryID,
        SubCategoryID: result?.SubCategoryID,
        ProductID: result?.ProductID,
        SizeID: result?.SizeID,
        Finish: result?.Finish,
        Thickness: result?.Thickness,
        Description: result?.Description,
        MetaTitle: result?.MetaTitle,
        MetaDescription: result?.MetaDescription,
        MainImage: result?.MainImage,
        MetaKeywords: result?.MetaKeywords,
        ProductImageDetails: result?.ProductImageDetails,
        IsActive: result.IsActive ? 1 : 2,
      } as IProduct;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Product :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveProduct = createAsyncThunk(
  "Product/FindAllActiveProduct",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Product/FindAllActiveProduct`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Product:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveProduct = createAsyncThunk(
  "Product/ActiveInActiveProduct",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Product/ActiveInActiveProduct`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Product :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const ProductImageUpload = createAsyncThunk(
  "Product/ProductImageAdd",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Product/ProductImageAdd`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Product Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ProductMainImageUpload = createAsyncThunk(
  "Product/ProductMainImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Product/ProductMainImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Product Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteProductImages = createAsyncThunk(
  "Product/DeleteProductImage",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Product/DeleteProductImage`,
        {
          ID: ID,
        }
      );

      if (response.data.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else if (response.data.Status === 201) {
        throw new Error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.message || "Something went wrong");
      console.error("ERROR : Delete PFS:", error);
      return Promise.reject({
        message: error?.message || "Something went wrong",
      });
    }
  }
);

export const FindAllCategoryWiseSubCategoryList = createAsyncThunk(
  "SubCategory/FindAllCategoryWiseSubCategoryList",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/SubCategory/FindAllCategoryWiseSubCategoryList`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Banner:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
